<template>
  <div>
    <van-overlay :show="loading">
      <div class="wrapper">
        <van-loading type="spinner" />
      </div>
    </van-overlay>
    <div class="bsd_inf">
      <van-tabs v-model="active" :color="$theme.main_color_btn_bg" @change="handleChange">
        <van-tab name="1" title="今天"></van-tab>
        <van-tab name="2" title="本周"></van-tab>
        <van-tab name="3" title="本月"></van-tab>
        <van-tab name="4" title="本季度"></van-tab>
      </van-tabs>
      <div class="bsd_heg"></div>
      <div class="bsd_tt">
        <span class="shi">时间筛选</span>
        <span class="yuan" @click="bsvisible = true">
          {{beginTime}}
          <van-icon class="rig" name="arrow-down" color="#999999" size="6"/>
        </span>
        <span class="jian">-</span>
        <span class="yuan" @click="bevisible = true">
          {{endTime}}
          <van-icon class="rig" name="arrow-down" color="#999999" size="6"/>
        </span>
        <span class="cha" @click="checkFun">查询</span>
      </div>

      <div class="bsd_hed">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div class="bsd_cnt" v-for="(item,index) in list" :key="index">
            <div class="title">
              <div class="d1">{{item.beesName}}</div>
              <div class="d2">{{item.beesType}}</div>
            </div>
            <ul class="cont">
              <li class="li">
                <p class="tid">订单额</p>
                <p class="text">{{item.orderTotle}}</p>
              </li>
              <li class="li">
                <p class="tid">子订单数</p>
                <p class="text">{{item.subOrderCount}}</p>
              </li>
              <li class="li">
                <p class="tid">订单商品数</p>
                <p class="text">{{item.itemCount}}</p>
              </li>
              <li class="li">
                <p class="tid">下单人数</p>
                <p class="text">{{item.customerCount}}</p>
              </li>
              <li class="li">
                <p class="tid">客单价</p>
                <p class="text">{{item.atvPrice}}</p>
              </li>
              <li class="li">
                <p class="tid">退款订单金额</p>
                <p class="text">{{item.cancelPrice}}</p>
              </li>
              <li class="li">
                <p class="tid">退款订单数</p>
                <p class="text">{{item.cancelOrderCount}}</p>
              </li>
              <li class="li">
                <p class="tid">退货用户数</p>
                <p class="text">{{item.afterCustomerCount}}</p>
              </li>
              <li class="li">
                <p class="tid">已结算退货订单金额</p>
                <p class="text">{{item.finishAfterPrice}}</p>
              </li>
              <li class="li">
                <p class="tid">用户申请退货订单金额</p>
                <p class="text">{{item.applyAfterPrice}}</p>
              </li>
               <li class="li">
                <p class="tid">售后单数</p>
                <p class="text">{{item.afterCount}}</p>
              </li>
              <li class="li">
                <p class="tid">退款订单用户数</p>
                <p class="text">{{item.cancelCustomerCount}}</p>
              </li>
              <li class="li">
                <p class="tid">平台承担优惠金额</p>
                <p class="text">{{item.platformDiscountAmount}}</p>
              </li>
              <li class="li">
                <p class="tid">店铺承担优惠金额</p>
                <p class="text">{{item.branchDiscountAmount}}</p>
              </li>
              <li class="li">
                <p class="tid">实付金额</p>
                <p class="text">{{item.actualPayAmount}}</p>
              </li>
              <li class="li">
                <p class="tid">订单运费金额</p>
                <p class="text">{{item.orderFreightAmount}}</p>
              </li>
              <li class="li">
                <p class="tid">订单运费优惠金额</p>
                <p class="text">{{item.orderFreightDiscountAmount}}</p>
              </li>
              <li class="li">
                <p class="tid">订单运费实付金额</p>
                <p class="text">{{item.orderFreightActualAmount}}</p>
              </li>
            </ul>
          </div>
        </van-list>
      </div>
    </div>
    <van-popup
      v-model="bsvisible"
      :closeable="false"
      round
      position="bottom"
      :style="{ height: '50%' }"
    >
      <van-datetime-picker
        @confirm="changeStartTimeFun"
        @cancel="bsvisible = false"
        v-model="currentDate"
        type="date"
        title="开始日期"
        :formatter="formatter"
      />
    </van-popup>
    <van-popup
      v-model="bevisible"
      :closeable="false"
      round
      position="bottom"
      :style="{ height: '50%' }"
    >
      <van-datetime-picker
        @cancel="bevisible = false"
        @confirm="changeEndTimeFun"
        v-model="currentDate"
        type="date"
        title="结束日期"
        :formatter="formatter"
      />
    </van-popup>
  </div>
</template>
<script>
import http from "@/utils/axios";
export default {
  name: '',
  props: {
    
  },
  data() {
    return {
      active:'1',
      loading:false,
      finished:false,
      list:[],
      pageIndex: 1,
      pageSize: 10,
      bsvisible:false,
      bevisible:false,
      beginTime: '',
      endTime: '',
      currentDate: new Date(),
      formInline: {
        1: '',
        2: '',
        3: '',
        4: '',
      },
    }
  },
  methods: {
    getNowTime() {
      const now = new Date()
      let year = now.getFullYear() //得到年份
      let month = now.getMonth() //得到月份
      let date = now.getDate() //得到日期
      month = month + 1
      month = month.toString().padStart(2, '0')
      date = date.toString().padStart(2, '0')
      let date_rel = year + '-' + month + '-' + date
      this.beginTime = date_rel
      this.endTime = date_rel
      let t90 = this.fun_date(90)
      let t30 = this.fun_date(30)
      let t7 = this.fun_date(7)
      this.formInline['4'] = t90 + '~' + date_rel
      this.formInline['3'] = t30 + '~' + date_rel
      this.formInline['2'] = t7 + '~' + date_rel
      this.formInline['1'] = date_rel + '~' + date_rel
    },
    fun_date(num) {
      let date1 = new Date()
      let date2 = new Date(date1)
      date2.setDate(date1.getDate() - num)
      //num是正数表示之后的时间，num负数表示之前的时间，0表示今天
      let month = (date2.getMonth() + 1).toString().padStart(2, '0')
      let date = date2.getDate().toString().padStart(2, '0')
      let time2 = date2.getFullYear() + '-' + month + '-' + date
      // console.log(time2)
      return time2
    },
    onLoad(){
      let parm = {
        beesId: '',
        orderType: 'ALL',
        beginTime: this.beginTime,
        endTime: this.endTime,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize || 10,
      }
      http({
        url: "report/order/report/beesOrderList",
        method: "post",
        parmes: parm
      })
      .then(rps => {
        if (rps.code === 200) {
          this.list = this.list.concat(rps.data.list)
          if (rps.data.pages == 0) {
            this.finished = true;
          }else if(rps.data.pages == 1){
            this.list = rps.data.list;
            this.finished = true;
          } else {
            if (rps.data.list.length === 0) {
              this.finished = true;
            } else {
              this.finished = false;
              this.pageIndex++;
            }
            this.list = this.list.concat(rps.data.list);
          }
          this.loading = false;
          this.$loading.hide();
        }
      })
      .catch(rps => {
        this.$loading.hide();
      });
    },
    formatter(type, val) {
      if (type === 'year') {
        return `${val}年`;
      } else if (type === 'month') {
        return `${val}月`;
      }else if (type === 'day') {
        return `${val}日`;
      }
      return val;
    },
    handleChange(val){
      let temp = this.formInline[this.active].split('~')
      this.beginTime = temp[0];
      this.endTime = temp[1];
      this.setDefaultParm()
    },
    changeStartTimeFun(val){
      this.beginTime = this.getFormatTime(val)
      this.bsvisible = false
    },
    changeEndTimeFun(val){
      this.endTime = this.getFormatTime(val)
      this.bevisible = false
    },
    getFormatTime(val){
      const time = new Date(val)
      let year = time.getFullYear() //得到年份
      let month = time.getMonth() //得到月份
      let date = time.getDate() //得到日期
      month = month + 1
      month = month.toString().padStart(2, '0')
      date = date.toString().padStart(2, '0')
      let format = year + '-' + month + '-' + date
      return format
    },
    checkFun(){
      if(this.endTime && this.beginTime){
        let bt = Number((this.beginTime.split('-')).join(''))
        let et = Number((this.endTime.split('-')).join(''))
        if(bt > et){
          this.$toast('开始日期不得大于结束日期')
          return
        }
      }
      // this.active = '-1'
      this.setDefaultParm()
    },
    setDefaultParm(){
      this.pageIndex =1
      this.list = []
      this.$loading.show()
      this.onLoad()
    }
  },
  created() {
    this.getNowTime()
  },
  mounted(){},
  computed:{},
  components: {},
  beforeCreate(){
    document.title = `${this.$theme.system_text_shoppers}订单明细`;
  },
};
</script>
<style lang="less" scoped>
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  font-size: 20px;
}
.bsd_inf{
  .bsd_heg{
    border-bottom: 1PX solid #F2F2F2;
  }
  .bsd_tt{
    height: 73px;
    line-height: 73px;
    font-size: 24px;
    color: #999999;
    padding-left: 40px;
    background-color: #ffffff;
    margin-bottom: 10px;
    display: flex;
    justify-content:flex-start;
    .shi{
      margin-right: 20px;
    }
    .jian{
      margin-right: 20px;
      margin-left: 20px;
    }
    .yuan{
      display: block;
      width: 180px;
      height: 50px;
      line-height: 50px;
      margin-top: 10px;
      background: #FFFFFF;
      border-radius: 10px;
      border: 1PX solid #999999;
      padding-left: 15px;
      clear: both;
      .rig{
        float: right;
        margin-top: 15px;
        margin-right: 15px;
      }
    }
    .cha{
      margin-left: 50px;
      cursor: pointer;
    }
  }
  .bsd_hed{
    padding-bottom: 20px;
    .bsd_cnt{
      .title{
        height: 73px;
        line-height: 73px;
        display: flex;
        justify-content:flex-start;
        background-color: #ffffff;
        border-bottom: 1PX solid #F7F7F7;
        .d1{
          font-size: 24px;
          color: #333333;
          margin-left: 40px;
        }
        .d2{
          font-size: 24px;
          color: #999999;
          margin-left: 44px;
        }
      }
      .cont{
        background-color: #ffffff;
        padding-left: 20px;
        padding-top: 20px;
        padding-bottom: 20px;
        color: #999999;
        font-size: 20px;
        .li{
          display: inline-block;
          text-align: center;
          .tid{
            background-color: #F2F2F2;
            width: 170px;
            height: 50px;
            padding-right: 8px;
            vertical-align: middle;
          }
          .text{
            background-color: #ffffff;
            padding-top: 14px;
            padding-bottom: 13px;
            width: 170px;
          }
        }
      }
    }
  }
}
</style>